import { Service, Inject } from 'vue-di-container';
import HttpService from './httpService';
import UserModel from '@/models/user';

@Service()
export default class CurrentUserAccessor {
  @Inject(HttpService) public httpService!: HttpService;

  private cachedUser!: UserModel;

  public async GetCurrentUser(): Promise<UserModel> {
    if (this.cachedUser) {
      return this.cachedUser;
    }

    try {
      const result = await this.httpService.httpInstance.get<UserModel>('api/UserInfo');

      this.cachedUser = result.data;

      return this.cachedUser;
    } catch (exception) {
      return {} as UserModel;
    }
  }
}
